export default {
    BillRows: 'البند|البنود',
};
